
/**
 * ��ȡ�û��ĵ�¼��Ϣ��Ŀǰ������Դ�� localStorage.
 * @author Huanping Zhang
 * @since 2019-08-13
 */
export class AuthInfo{

    constructor(
    ){}
    
    static DetailKeys = {
        token      :   "token"      ,
        appId      :   "appId"      ,
        authorg    :   "authorg"    ,
        authsites  :   "authsites"  ,
        defsite    :   "defsite"    ,
        realname   :   "realname"   ,
        resources  :   "resources"  ,
        userId     :   "userId"     ,
        userName   :   "userName"   ,
        authScope  :   "authScope"  ,
        authorizes :   "authorizes" ,
        roles      :   "roles"
    }
    
    static DETAILS  = null;
    
    static refreshLocalStorageUserInfo(){
        
        let token      = localStorage.getItem("token"        ) ;
		let appId      = localStorage.getItem("appId"        ) ;
		let userName   = localStorage.getItem("username"     ) ;
		let userId     = localStorage.getItem("userid"       ) ;
		let realname   = localStorage.getItem("realname"     ) ;
		let authorg    = localStorage.getItem("authorg"      ) ;
		let defsite    = localStorage.getItem("defsite"      ) ;
		let authsites  = localStorage.getItem("authsites"    );
		
		if( authsites ){
		    authsites = "[" + authsites.replace(/\"/g,"").replace(/'/g,"\"") + "]";
		    authsites = JSON.parse( authsites );
		}
		
		let resources  = JSON.parse( localStorage.getItem("resources"    ) ) ;
		let newResources = [];
		
		let i=0;
		for( let key in resources ){
		    newResources[i] = key;
		    i++
		}
        
        let details = {
        
            "token"        : token                               ,
            "appId"        : appId                               ,
            "authorg"      : authorg                             ,
            "authsites"    : authsites                           ,
            "defsite"      : defsite                             ,
            "realname"     : realname                            ,
            "userId"       : userId                              ,
            "userName"     : userName                            ,
            "authScope"    : { 
                "userId"  : userId ,
                "sites"   : authsites,
                "orgs"    : authorg 
            },
            authorizes : newResources
        }
        
        AuthInfo.DETAILS = details;
    } 
    
    static refresh(){
        try{
            AuthInfo.refreshLocalStorageUserInfo();
        }catch(error){
            console.error( "No auth info, user may not login yet." );
        }
    }
    
    static clear(){
        
        try{
            AuthInfo.DETAILS = {}; 
        }catch(error){
            console.error( "No auth info, user may not login yet." );
        }
    }
    
    static isLogin(){
    
        let me = this;
        
        if( !AuthInfo.DETAILS ){
            AuthInfo.refresh();
        }
    
        let token = AuthInfo.DETAILS[ AuthInfo.DetailKeys.token ];
        
        if( token && token.length > 0 ){
        
            if( token == "null" && token == "undefined" ){
                return false;
            }
            return true;
        }
        
        return false;
    }
    
    static get token(){
    
        if( !AuthInfo.DETAILS || AuthInfo.DETAILS.length <= 0){
            AuthInfo.refreshLocalStorageUserInfo();
        }
    
        return AuthInfo.DETAILS.token;
    }
    
    static get details(){
    
        if( !AuthInfo.DETAILS || AuthInfo.DETAILS.length <= 0){
            AuthInfo.refreshLocalStorageUserInfo();
        }
    
        return AuthInfo.DETAILS;
    }
    
    static get userName(){
        
        if( AuthInfo.details ){
            return AuthInfo.details[ AuthInfo.DetailKeys.userName ];
        }
        
        return null;
    }
    
    static get userId(){

        if( AuthInfo.details ){
            return AuthInfo.details[ AuthInfo.DetailKeys.userId ];
        }
        
        return null;
    }
    
    static get userRealName(){
    
        if( AuthInfo.details ){
            return AuthInfo.details[ AuthInfo.DetailKeys.realname ];
        }
        return null;
    }
    
    static get authScope(){
        if( AuthInfo.details ){
            return AuthInfo.details[ AuthInfo.DetailKeys.authScope ];
        }
        return null;
    }
    
    static get roles(){
        if( AuthInfo.details ){
            return AuthInfo.details[ AuthInfo.DetailKeys.authorizes ];
        }
        return null;
    }
    
    static get authorizes(){
        if( AuthInfo.details ){
            return AuthInfo.details[ AuthInfo.DetailKeys.authorizes ];
        }
        return null;
    }
}